module.exports = __webpack_public_path__ + "scan-a6f74268b08617ffeecae3945b9e95f9.png";